/* eslint-disable @sailor/base-no-side-effects-in-default-params */
import useRuleConfig, { IExpiryConfigItem } from '@/common/recoil/atom/ruleConfigAtom'
import  Radio from '@roo/roo/Radio'
import React, { useEffect, useRef } from 'react'
import { FormPro } from '@roo/roo'
import { FormInstance } from '@roo/roo/FormPro'
import QuestionTooltip from '@/components/QuestionTooltip'
import { getNumStr, isEqualString } from '@/common/utils'
import { useFormContext } from '../../context/formContext'
import Input from '@roo/roo/Input'
import { useEffectOnece } from '@/hooks'


export interface IExpiryConfigiFe {
  /** 结束时间延长周期类型 */
  expiryType?: number,
  /** 结束时间延长周期值 */
  expiryValue?: string
  /** 是否需要填写值 */
  needFillValue?: boolean
  originData?:IExpiryConfigItem
}

interface Props {
  value?: IExpiryConfigiFe
  onChange?: (val:Props['value']) => void
  form: FormInstance
}

const ExpiryConfigFormItem = (props:Props) => {
  const { budgetFeeConfig } = useRuleConfig() || {}

  const { value: propVal, onChange = () => {} } = props
  const formPeriodType = FormPro.useWatch('periodType', props.form)
  const { effectStatusMap, formStatus } = useFormContext()
  const periodTypeInitedRef = useRef(false) // 下发方式是否已完成初始化

  const expiryConfigMap = budgetFeeConfig?.periodConfig.reduce((result, item) => {
    if (item.expiryConfigList?.length) {
      result[String(item.periodType)] = item.expiryConfigList
    }
    return result
  }, {})

  const expiryConfigList = expiryConfigMap[String(formPeriodType)] as IExpiryConfigItem[]
  const  findSelectedItem = (expiryType:any = propVal?.expiryType) => expiryConfigList?.find(item => isEqualString(expiryType, item.expiryType))

  useEffect(() => {
    const inited = formStatus.isCreate || periodTypeInitedRef.current
    if (expiryConfigList?.length && inited) {
      handleValChange(expiryConfigList[0], '1')
    }
    periodTypeInitedRef.current = Boolean(getNumStr(formPeriodType))
  }, [formPeriodType])

  function handleChange (newType:string) {
    const selectedItem = findSelectedItem(newType) as IExpiryConfigItem
    handleValChange(selectedItem, propVal?.expiryValue || '')
  }

  function handleInputChange (e, item: IExpiryConfigItem) {
    const newVal = e.target.value || ''
    // if (/^[1-9]\d*$/.test(newVal) || newVal === '') {
    handleValChange(item, newVal)
    // }
  }

  function handleValChange (item:IExpiryConfigItem, inputVal = '') {
    onChange({
      expiryValue: inputVal,
      expiryType: item.expiryType,
      needFillValue: item?.needFillValue,
      originData: item,
    })
  }

  useEffectOnece(() => {// 首次加载,有expiryConfigList与value,填充needFill
    const selectedItem = findSelectedItem(propVal?.expiryType)
    if (selectedItem) {
      handleValChange(selectedItem, propVal?.expiryValue)
    }
  }, expiryConfigList?.length && propVal?.expiryType) // 首次

  const disabled = effectStatusMap.isExpired
  return (
    <Radio.Group disabled={disabled} onChange={handleChange} value={String(propVal?.expiryType)}>
      {expiryConfigList?.map(item => (
        <Radio value={getNumStr(item.expiryType)} key={item.expiryType} >
          <div style={{ display: 'flex', whiteSpace: 'nowrap', alignItems: 'center' }}>
            {item.needFillValue && (
              disabled
                ? propVal?.expiryValue
                : <Input  style={{ width: '45px', minHeight: '25px', height: '25px' }} value={propVal?.expiryValue} onChange={(e) => handleInputChange(e, item)} />
            )}&nbsp;
            {item.name}
            {item.tips && <QuestionTooltip>{item.tips}</QuestionTooltip>}
          </div>
        </Radio>
      ))}
    </Radio.Group>
  )
}
export default ExpiryConfigFormItem